/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { EventBus as IEventBus } from "App/Contracts";
import EventEmitter3 from "App/Externals/EventEmitter3";

/* The shared application event bus singleton, extracted out of the IOC barrel so that
   leaf modules (notably BaseService) can depend on it WITHOUT importing the whole
   "App/IOC" barrel. That Base -> App/IOC edge formed an import cycle whose resolution
   order decided whether the Subscriptions service got emitted as an ES5 class, which
   then broke super() against the native BaseService class
   ("Class constructor BaseService cannot be invoked without 'new'"). The barrel
   re-exports this same instance, so every existing consumer is unaffected. */
const EventBus: IEventBus = new EventEmitter3();

export { EventBus };
